import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileCheck2, Download } from "lucide-react";
import { toast } from "sonner";

export default function ComplianceReports() {
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth() + 1);
  const [data, setData] = useState(null);
  const generate = async () => {
    try {
      const r = await api.get(`/compliance/monthly-report?year=${year}&month=${month}`);
      setData(r.data);
      toast.success("Report generated");
    } catch { toast.error("Failed"); }
  };
  const download = () => {
    if (!data) return;
    const blob = new Blob([data.markdown], { type: "text/markdown" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `compliance-${year}-${String(month).padStart(2, "0")}.md`;
    a.click();
  };
  return (
    <div className="space-y-6 animate-slide-up" data-testid="compliance-page">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-cyan-600/15 border border-cyan-500/20 flex items-center justify-center"><FileCheck2 className="w-6 h-6 text-cyan-400" /></div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold mb-1">Admin · Compliance</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Compliance Reports</h1>
          <p className="text-sm text-slate-400 mt-1">Monthly OEM/State Commission attestation · ESIGN/UETA compliant signatures · scan archive</p>
        </div>
      </div>
      <div className="rounded-xl border border-slate-800 bg-[#0B1120] p-5 flex items-center gap-3">
        <select data-testid="year-select" value={year} onChange={(e) => setYear(parseInt(e.target.value))} className="bg-[#030712] border border-slate-800 rounded-lg p-2 text-sm">
          {[year - 2, year - 1, year].map((y) => <option key={y}>{y}</option>)}
        </select>
        <select data-testid="month-select" value={month} onChange={(e) => setMonth(parseInt(e.target.value))} className="bg-[#030712] border border-slate-800 rounded-lg p-2 text-sm">
          {Array.from({ length: 12 }).map((_, i) => <option key={i+1} value={i+1}>{new Date(2000, i, 1).toLocaleString('en', { month: 'long' })}</option>)}
        </select>
        <Button data-testid="generate-btn" onClick={generate} className="bg-cyan-600 hover:bg-cyan-500">Generate Report</Button>
        {data && <Button data-testid="download-btn" onClick={download} variant="outline" className="border-slate-700 bg-slate-900/40"><Download className="w-4 h-4 mr-2" />Download MD</Button>}
      </div>
      {data && (
        <div className="rounded-xl border border-slate-800 bg-[#0B1120] p-5">
          <div className="grid grid-cols-5 gap-3 mb-4">
            {Object.entries(data.stats).map(([k, v]) => (
              <div key={k} className="rounded-lg bg-slate-900/40 border border-slate-800 p-3">
                <div className="text-[9px] uppercase tracking-wider font-bold text-slate-500">{k.replace("_", " ")}</div>
                <div className="font-display text-xl font-semibold mt-1">{typeof v === "number" && k.includes("paid") || k.includes("pending") ? `$${v.toLocaleString()}` : v}</div>
              </div>
            ))}
          </div>
          <pre className="text-xs text-slate-300 bg-slate-900/40 border border-slate-800 rounded-lg p-4 whitespace-pre-wrap font-mono">{data.markdown}</pre>
        </div>
      )}
    </div>
  );
}
